import { phoneNumberFormatter } from '../phoneNumberFormatter'

$(() => {
  const $form = $('form#users-contacts-form');

  if ($form.length === 0) {
    return;
  }

  const primaryPhoneNumberInput = $form[0].querySelector('#phone_number_input');
  const primaryPhoneNumberErrorMessage = $form[0].querySelector('#phone_number_error_message');

  phoneNumberFormatter(primaryPhoneNumberInput, primaryPhoneNumberErrorMessage);
});
